import { useAuth } from '@/hooks/use-auth'
import { Navigate } from '@tanstack/react-router'
import { Card, CardContent } from '@/components/ui/card'

interface ProtectedRouteProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function ProtectedRoute({ children, fallback }: ProtectedRouteProps) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      fallback || (
        <div className="min-h-screen flex items-center justify-center bg-[#f7f3ea]">
          <Card className="w-full max-w-md bg-white/80 shadow-sm">
            <CardContent className="flex items-center justify-center py-12">
              <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-stone-800 mx-auto mb-4"></div>
                <p className="text-stone-600">Loading...</p>
              </div>
            </CardContent>
          </Card>
        </div>
      )
    )
  }

  if (!user) {
    return <Navigate to="/login" />
  }

  return <>{children}</>
}
